import React from 'react';
import './FeaturedCreditsTooltip.css';

const FeaturedCreditsTooltip = () => {
  return (
    <div className="featured-credits-tooltip">
      <strong>Earn free credits!</strong>
      <p style={{color: '#fff !important'}}>Refer a friend—when they post their first ad, you get 1 credit and they get 2.</p>
      <p>WhatsApp ad photos to 6305066105 to claim.</p>
    </div>
  );
};

export default FeaturedCreditsTooltip;